export default {
    '1.0.7': [
        '* Добавлен псевдо тег превью картинкам, который не позволит браузеру их кэшировать;'
    ],
    '1.0.6': [
        '* Добавлены цвета ролей на странице пользователей в зависимости от их прав;',
        '* Исправлена позиция версии из-за чего перекрывалась кнопка переключения цвета;',
        '* Исправлено округление цвета при использовании собственных цветов.'
    ],
    '1.0.5': [
        '* Добавлена "прозрачная" текстура для превью изображений.'
    ],
    '1.0.4.2 BugFix': [
        '* Исправлен баг с бесконечной загрузкой из-за ошибки в системе popup-ов;',
        '* Исправлен баг с невозможностью сохранить данные при комбинировании ручного выставление фильтров и массового в разделе "theme";',
        '* Исправлен баг, что в MultiEdit при нажатии кнопки "clear", не очищались поля в разделе "theme";',
        '* Исправлена подгрузка из LocalStorage дополнительных цветов, до этого подгружался чёрный цвет.'
    ],
    '1.0.4.1': [
        '* Увеличено время показа popup с ошибкой с 2000 до 20000 миллисекунд (в 10 раз).'
    ],
    '1.0.4': [
        '* Добавлена возможность создать свой цвет;',
        '* В цвета добавлен "белый" цвет, который является собственным цветом;',
        '* Переработан внешний вид страницы настроек, теперь все настройки идут одним списком, а не блоками;',
        '* Добавлена стилизация главной полосы прокрутки.'
    ],
    '1.0.3.2': [
        '* Фильтры типа "popup" выводятся в несколько столбцов, вместо длинного списка;',
        '* Добавлен заголовок отображающий текущего провайдера и игру при разметке.'
    ],
    '1.0.3.1 Optimization': [
        '* Добавлен в headers всех запросов "Cache-Control: no-cache".'
    ],
    '1.0.3': [
        '* Добавлен popup подтверждения;',
        '* Удаление игр и провайдеров теперь происходит через подтверждающий popup.'
    ],
    '1.0.2': [
        '* Убран жирный шрифт из таблицы, на странице добавления/редактирования пользователей;',
        '* Добавлен новый цвет для игр, у которых 0 опубликованных картинок. На главной странице;',
        '* Добавлены заголовки для разделов на главной странице, в левой панели.'
    ],
    '1.0.1.1 BugFix': [
        '* Исправлен цвет кнопок в меню MultiEdit и GlobalSearch в разделе Tags, раньше ' +
        'кнопки не меняли цвет при смене темы, стоял не тот CSS стиль;',
        '* Исправлена множественная замена на null (none) значение, не корректно срабатывала ' +
        'проверка на пустое поле, учитывались только NaN, теперь учитываются и Null.'
    ],
    '1.0.1': [
        '* Переименована кнопка проверки Additional Tags с \'Clear Text\' на \'Check Text\';',
        '* Добавлена возможность сортировки пользователей по заголовку таблицы. ' +
        'Сортировка возможа по возрастанию или по убываний, а также возврат к стандратному варианту;',
        '* При изменении страницы в списке файлов, теперь происходит подъём на верх страницы.'
    ],
    '1.0.0': [
        '* Релиз.'
    ],
    '0.2.10.2': [
        '* Теперь списки Фильтров, Игр, Провайдеров, Тегов, Пользовательских фильтров, ' +
        'Пользователей и Ролей выводятся по алфавиту.'
    ],
    '0.2.10.1': [
        '* Обновлена система запросов, проведена унификация запросов;',
        '* Добавлен эффект наведения, на основные цвета в настройках;',
        '* Проведена стандартизация стилей, убраны лишние классы в css;',
        '* Добавлен вывод общего числа игр и провайдеров на главную страницу;',
        '* Добавлен Checkbox на 3 состояния, который используется в MultiEdit, ' +
        'в фильтрах множественного значения, вместо двух отдельных Checkbox;',
        '* Изменены цвета у основного цвета \'pink\', тёмные и светлые заменены местами.'
    ],
    '0.2.10': [
        '* Добавлена страница для редактирования пользовательских фильтров;',
        '* Добавлена возможность добавлять новые общие Smart Filter;',
        '* Добавлена возможность изменять Smart FIlter;',
        '* Добавлена возможность удалить Smart Filter.'
    ],
    '0.2.9': [
        '* Добавлена страница для редактирования Asset Type;',
        '* Добавлена возможность добавлять новые Asset Type;',
        '* Добавлена возможность изменять Asset Type;',
        '* Добавлена возможность сменить изображение у Asset Type при его редактировании.'
    ],
    '0.2.8': [
        '* Добавлен changelog и отдельная страница для него;',
        '* Добавлена возможность сменить изображение у провайдера при его редактировании;',
        '* Добавлена возможность сменить изображение у фильтра при его редактировании.'
    ],
}